module.exports = __webpack_public_path__ + "img/fruit-melons-190x100.d5ebc193.jpg";